export const CoverageMeter = ({ pct, hint, compact }) => (
  <div data-testid="coverage-meter" className={compact ? "" : "space-y-2"}>
    <div className="flex items-baseline justify-between gap-4">
      <span className="ss-mono text-[11px] uppercase tracking-[0.16em] text-[color:var(--ink)]">
        Scorecard coverage
      </span>
      <span className="ss-mono text-sm font-semibold text-[color:var(--ink)]" data-testid="coverage-pct">
        {pct}%
      </span>
    </div>
    <div className="ss-progress-track mt-1">
      <div className="ss-progress-fill" style={{ width: `${Math.min(pct, 100)}%` }} />
    </div>
    {hint && (
      <p className="text-xs text-[color:var(--grey)] mt-2" data-testid="coverage-hint">
        Add your <span className="font-semibold text-[color:var(--ink)]">{hint.name}</span> to unlock{" "}
        {hint.unlock.toLowerCase()}
      </p>
    )}
  </div>
);
